// extracted by mini-css-extract-plugin
export default {"lineItemsContainer":"PayeeOrderSummary_lineItemsContainer__mBi2j","lineItemTotal":"PayeeOrderSummary_lineItemTotal__LF4Fu"};